export default __webpack_public_path__ + "static/media/1.100a402c.png";